<template>
  <nav class="mx-0 bg-cWhiteBase shadow-sm">
    <div class="hidden md:block">
      <div class="flex justify-between md:mx-10 lg:mx-14 xl:mx-20 2xl:mx-28">
        <div>
          <router-link to="#beranda"
            ><img
              src="../assets/logo.png"
              alt=""
              class="w-logoHeader my-3 md:ml-2 lg:ml-4"
          /></router-link>
        </div>
        <div
          class="flex flex-wrap gap-8 justify-center my-auto md:-ml-20 2xl:mx-28"
        >
          <router-link to="#beranda"
            ><p
              class="text-sm font-semibold 2xl:text-base focus:border-b-2 focus:border-brownCLight pt-8 pb-7"
            >
              Beranda
            </p></router-link
          >
          <router-link to="#sedekah-kuy"
            ><p
              class="text-sm font-semibold 2xl:text-base py-1 focus:border-b-2 focus:border-brownCLight pt-8 pb-7"
            >
              Sedekah Kuy
            </p></router-link
          >
          <router-link to="#tentang"
            ><p
              class="text-sm font-semibold 2xl:text-base py-1 focus:border-b-2 focus:border-brownCLight pt-8 pb-7"
            >
              Tentang
            </p></router-link
          >
          <div class="mt-6">
            <router-link
              to="#donasi"
              class="inline-block text-sm px-4 py-2 leading-none font-semibold border-2 rounded text-cLightBlue tracking-widest border-cLightBlue hover:border-transparent hover:text-cWhiteBase hover:bg-cLightBlue mt-0 lg:mt-0"
            >
              DONASI
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="md:hidden -mt-4">
      <button @click="drawer" class="outline-none">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
          class="bi bi-list absolute my-5 ml-2 text-brownC"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
          />
        </svg>
      </button>
      <img src="../assets/logo.png" alt="" class="mx-auto w-3/12" />
    </div>

    <transition
      enter-class="opacity-0"
      enter-active-class="ease-out transition-medium"
      enter-to-class="opacity-100"
      leave-class="opacity-100"
      leave-active-class="ease-out transition-medium"
      leave-to-class="opacity-0"
    >
      <div
        @keydown.esc="isOpen = false"
        v-show="isOpen"
        class="z-10 fixed inset-0 transition-opacity"
      >
        <div
          @click="isOpen = false"
          class="absolute inset-0 bg-black opacity-50"
          tabindex="0"
        ></div>
      </div>
    </transition>
    <aside
      class="transform top-0 left-0 w-64 bg-white fixed h-full overflow-auto ease-in-out transition-all duration-300 z-30"
      :class="isOpen ? 'translate-x-0' : '-translate-x-full'"
    >
      <svg
        @click="drawer"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        class="bi bi-x ml-auto m-2"
        viewBox="0 0 16 16"
      >
        <path
          d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
        />
      </svg>
      <img src="../assets/logo.png" alt="" class="mx-auto w-6/12" />
      <span @click="isOpen = false" class="flex items-center px-4 pt-4"
        ><span class="mr-2"> </span>
        <router-link to="#beranda"
          ><p class="text-sm active:border-b-2 active:border-brownCLight py-1">
            Beranda
          </p></router-link
        ></span
      >
      <span @click="isOpen = false" class="flex items-center px-4 pt-4"
        ><span class="mr-2"> </span>
        <router-link to="#sedekah-kuy"
          ><p class="text-sm active:border-b-2 active:border-brownCLight py-1">
            Sedekah Kuy
          </p></router-link
        ></span
      >
      <span @click="isOpen = false" class="flex items-center px-4 pt-4"
        ><span class="mr-2"> </span>
        <router-link to="#tentang"
          ><p class="text-sm active:border-b-2 active:border-brownCLight py-1">
            Tentang
          </p></router-link
        ></span
      >
      <span @click="isOpen = false" class="flex items-center px-4 pt-4"
        ><span class="mr-2"> </span>
        <a
          href="#donasi"
          class="inline-block text-sm px-4 py-1 leading-none font-semibold border-2 rounded text-cLightBlue tracking-widest border-cLightBlue hover:border-transparent hover:text-cWhiteBase hover:bg-cLightBlue mt-0 lg:mt-0"
          >DONASI</a
        ></span
      >
    </aside>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    drawer() {
      this.isOpen = !this.isOpen;
    },
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(isOpen) {
        if (process.client) {
          if (isOpen) document.body.style.setProperty("overflow", "hidden");
          else document.body.style.removeProperty("overflow");
        }
      },
    },
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27 && this.isOpen) this.isOpen = false;
    });
  },
};
</script>

<style>
.router-link-active,
.router-link-exact-active {
  cursor: pointer;
  border-bottom: 2px solid #003556;
}
</style>